import { ApiResult } from "common/models";
import { HttpClient } from "common/services/http-client.service";
import { withApiResponse } from "common/utils/rtk-query.util";
import { knowledgeLibraryApiConfig } from "../config/knowledge-library-api.config";
import { KgFilterRequest } from "../models/knowledge-library.model";

export class KnowledgeLibraryService extends HttpClient {
  public static kgFilter(request: KgFilterRequest) {
    const config = knowledgeLibraryApiConfig.kgFilter(request);
    return withApiResponse<any>(async () => {
      const response = await this.invokeApi<any>(config);
      return new ApiResult<any>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }
}
